import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter'
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var rVal;
    if (!args) {
      return value;
    }
    return value.filter((val) => {
      // pages , menu
      if (val.name) {
        rVal = val.name.toLowerCase().includes(args);
      }
      // posts
      if (val.title) {
        rVal = val.title.toLowerCase().includes(args);
      }
      // media
      
      if (val.filename) {
        rVal = val.filename.toLowerCase().includes(args);
      }


      return rVal;
    });
  }
}
